<div class="flex-row flex">
    <div class="flex-col flex">
        <table mat-table
               #table
               class="cb-table"
               [dataSource]="categoryTree">
            <ng-container matColumnDef="categoryTreeItem">
                <th mat-header-cell
                    *matHeaderCellDef
                    style="width:50%">
                    Category Filter
                </th>
                <ng-container
                    *matCellDef="let categoryTreeItem;  let isLast = last; let isFirst = first; let i = index">
                    @if (!isLast) {
                        <td mat-cell
                            style="width:50%">
                            @if (categoryTreeItem.categories.length > 0 && !isLast) {
                                <span>
                  {{ categoryTreeItem.label }}
                </span>
                            }
                        </td>
                    }
                </ng-container>
            </ng-container>
            <ng-container matColumnDef="categoryTreeItemSelection">
                <th mat-header-cell
                    style="width:50%"
                    *matHeaderCellDef></th>
                <ng-container
                    *matCellDef="let categoryTreeItemSelection;  let isLast = last; let isFirst = first; let i = index">
                    @if (!isLast) {
                        <td mat-cell
                            style="width:50%"
                        >
                            @if (categoryTreeItemSelection.categories.length > 0 && !isLast) {
                                <span>
                  {{
                                        getSelectedCategoryLabel(categoryTreeItemSelection?.selectedCategory?.id,
                                            categoryTreeItemSelection?.categories)
                                    }}
                </span>
                            }
                        </td>
                    }
                </ng-container>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell
                    style="display: none;"
                    *matHeaderCellDef></th>
                <ng-container
                    *matCellDef="let categoryTreeItem;  let isLast = last; let isFirst = first; let i = index">
                    @if (isLast) {
                        <td mat-cell
                            colspan="2">
                            <div class="start-center flex-row"
                                 style="width: 100%;">
                                @if (categoryTreeItem.categories.length === 0) {
                                    <span class="mat-body-2 start-center flex-row flex"
                                          style="min-width: 400px">
                    <mat-icon class="mat-accent">
                      info
                    </mat-icon>
                    &nbsp;
                                        {{ categoryTreeItem.label }} does not have any child categories
                  </span>
                                }
                                @if (categoryTreeItem.categories.length > 0 && isLast) {
                                    <cb-select class="flex"
                                               [label]="categoryTreeItem.label"
                                               name="mainCategory"
                                               [options]="categoryTreeItem.categories"
                                               (change)="onCategorySelected($event, categoryTreeItem.categories)">
                                    </cb-select>
                                }
                                @if (isLast && !isFirst) {
                                    <button
                                        [hidden]="isLastCategoryRestricted()"
                                        [disabled]="isFetching"
                                        mat-icon-button
                                        (click)="removeLastCategory()">
                                        <mat-icon>remove_circle</mat-icon>
                                    </button>
                                }
                            </div>
                        </td>
                    }
                </ng-container>
            </ng-container>
            <tr mat-header-row
                *matHeaderRowDef="displayedColumns">
            </tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>
    </div>
</div>
